import moment from 'moment'
import Mask from '../constants/Mask'

export const brDate = date => moment(date).format(Mask.BR_DATE)
